import { outdoor_registry } from "./outdoor_registry";
import { random, round2, formatDateTime } from "../helpers/helpers";

export const generate_outdoor_latest_dashboard_demo = () => {
    const sensors = outdoor_registry.map(sensor => ({
        meter_id: sensor.meter_id,
        sensor_name: sensor.meter_name,

        status: "Online",
        last_seen: formatDateTime(new Date()),

        aqi: Math.round(random(40, 110)),

        temperature: round2(random(21, 32)),
        humidity: round2(random(30, 70)),

        pm10: round2(random(20, 120)),
        pm2: round2(random(10, 80)),

        co: round2(random(350, 800)),
        tvoc: round2(random(80, 350)),
        smoke: round2(random(1, 25)),
        formaldehyde: round2(random(5, 45)),

        is_temperature: true,
        is_humidity: true,
        is_pm10: true,
        is_pm2: true,
        is_co: true,
        is_co_monoxide: true,
        is_tvoc: true,
        is_smoke: true,
        is_formaldehyde: true,
        is_no2: true,
        is_o3: true,
        is_so2: true,
    }));

    return {
        active: sensors.length,
        inactive: 0,
        total: sensors.length,
        sensors,
    };
};